import { Button } from "../../../shadcn/Button"
import { Checkbox } from "../../../shadcn/Checkbox"
import { Label } from "../../../shadcn/Label"
import MyPageErrorMessages from "../../../components/mypage/MyPageErrorMessages"
import useSignupForm from "../hooks/useSignupForm"
import LINKS from "../../login/constant/links"
import { TextField } from "../../../components/TextField/TextField"
import type { EstimateDraft } from "../types/SignUpEstimate"
import { Stepper } from "./Stepper"

type Props = {
  onSuccess?: (email: string) => void
  estimateDraft?: EstimateDraft
  url: URL | null
  coupon?: string | undefined
}

export const SignupForm = ({ onSuccess, estimateDraft, url, coupon }: Props) => {
  const { email, agreedToTerms, onEmailChange, onAgreedToTermsChange, errorMessage, submit, isLoading } = useSignupForm(
    {
      onSuccess,
      estimateDraft,
      coupon,
      url,
    },
  )

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    submit()
  }

  return (
    <div className="flex w-full max-w-[800px] flex-col items-start rounded-xl bg-white p-8">
      <div className="mb-12 w-full">
        <Stepper currentStep={1} />
      </div>
      <h2 className="mb-6 text-2xl font-semibold text-gray-800">新規ユーザー登録</h2>
      <div className="mb-16 w-full text-base leading-[1.5] text-gray-800">
        <p className="mb-0">入力メールアドレスに登録確認メールをお送りします。</p>
        <p>迷惑メール防止設定をしている方は「@p-ban.com」のドメイン指定解除をしてください。</p>
      </div>
      {errorMessage && (
        <div className="mb-6">
          <MyPageErrorMessages>{errorMessage}</MyPageErrorMessages>
        </div>
      )}
      <form className="w-full" onSubmit={handleSubmit}>
        <div className="mb-6 flex w-full items-center gap-7">
          <label className="flex w-32 items-center gap-1 whitespace-nowrap text-base font-semibold text-gray-800">
            <span>メールアドレス</span>
            <abbr className="text-sm text-red-600 no-underline" title="必須">
              *
            </abbr>
          </label>
          <div className="max-w-[424px] flex-1">
            <TextField
              type="email"
              placeholder="メールアドレスを入力してください"
              value={email}
              onChange={onEmailChange}
              isError={!!errorMessage}
              id="signup-email"
              required
            />
          </div>
        </div>
        <div className="mb-16 flex w-full items-center gap-7">
          <div className="w-32" />
          <div className="flex h-[48px] w-[424px] items-center rounded-[8px] bg-[#E0F2FE] px-3 py-2">
            <Label className="flex flex-1 cursor-pointer items-center gap-0">
              <div className="flex items-center justify-center p-[9px]">
                <Checkbox checked={agreedToTerms} onCheckedChange={onAgreedToTermsChange} />
              </div>
              <span className="text-sm text-[#32383e]">
                <a
                  href={LINKS.TERMS_OF_SERVICE}
                  target="_blank"
                  rel="noreferrer"
                  className="text-green-600 underline decoration-solid hover:text-green-700"
                >
                  P板.comの利用規約
                </a>
                に同意します
              </span>
            </Label>
          </div>
        </div>
        <div className="flex justify-center">
          <Button
            type="submit"
            disabled={!email || !agreedToTerms || isLoading}
            className="w-[240px] rounded-3xl bg-green-600 px-[22px] py-2 text-[15px] font-medium text-white hover:bg-green-700 disabled:opacity-50"
          >
            確認メールを送信
          </Button>
        </div>
      </form>
    </div>
  )
}
